<div style="width: 450px;">
  <h1 mat-dialog-title>You want to log out</h1><hr>
  <div mat-dialog-content>Please press the button to confirm.</div>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button [mat-dialog-close]="true" (click)="logoutapp()" cdkFocusInitial>Confirm</button>
  </mat-dialog-actions>
</div>